import { Controller } from "@hotwired/stimulus"

// Simple debounce function
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Connects to data-controller="bank-account-search"
export default class extends Controller {
  static targets = [ "query", "results" ]

  connect() {
    // Debounce the actual search function
    this.performSearch = debounce(this._performSearch, 400) // 400ms delay
  }

  // This method is triggered directly by the keyup-> action
  searchWithDebounce(event) {
    // Prevent form submission if Enter key is pressed in the input
    if (event.key === 'Enter') {
        event.preventDefault(); 
    }
    // Call the debounced search function
    this.performSearch()
  }

  // This method is triggered by the form submit-> action (button click or Enter)
  search(event) {
    if (event) event.preventDefault() // Prevent default form submission
    this.performSearch() // Trigger the debounced search immediately on submit
  }

  // Internal search logic, wrapped by debounce
  _performSearch() {
    const query = this.queryTarget.value
    // Assuming the form is the direct parent or easily accessible
    const form = this.element.querySelector('form') 
    if (!form) { 
        console.error("Form not found for search"); 
        return; 
    }
    const url = form.action 
    const formData = new FormData(form)
    
    // Ensure query is included if triggered by keyup without form data
    if (!formData.has('query')) {
        formData.append('query', query);
    }

    this.resultsTarget.innerHTML = '<p>Searching...</p>'; // Indicate loading

    fetch(url, {
      method: "POST",
      headers: {
        "Accept": "text/javascript", 
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => response.text()) 
    .then(javascript => {
      eval(javascript) 
    })
    .catch(error => {
      console.error("Search failed:", error);
      this.resultsTarget.innerHTML = "<p class='text-danger'>Search failed. Please try again.</p>"
    })
    .finally(() => {
      // Clear loading message if results are empty
      if (this.resultsTarget.innerHTML === '<p>Searching...</p>') {
        this.resultsTarget.innerHTML = '';
      }
    });
  }
} 